import { RootAppState } from '../types';

export const getChain = (state: RootAppState) => state.navigation.chain;
export const getPrevUrl = (state: RootAppState) => state.navigation.prevUrl;
export const getElementIDInViewPort = (state: RootAppState) => state.navigation.elementIdInViewport;
